// Export the DrawerComponent class for other modules to extend
export class IaDrawer extends HTMLElement {
  constructor() {
    super();
    this.id = this.dataset.drawerId;
    this.isOpen = this.classList.contains('is-open');
    this.overlay = this.querySelector('[data-drawer-overlay]');
    this.window = this.querySelector('[data-drawer-window]');
    this.drawerOpener = document.querySelectorAll(`[data-drawer-trigger="${this.id}"]`);
    
    this.drawerOpener?.forEach(drawerOpener => {
      drawerOpener.addEventListener('click', this.toggleDrawer.bind(this));
    });
    
    document.addEventListener('keyup', (e) => {
      if (!this.isOpen) return
      if (e.key === 'Escape') {
        this.close()
      }
    })
    
    this.overlay?.addEventListener('click', this.close.bind(this));
  }

  connectedCallback() {
    if (this.parentNode !== document.body) {
      document.body.appendChild(this);
    }
  }

  toggleDrawer(event) {
    event.preventDefault();
    this.isOpen = !this.isOpen;
    this.isOpen ? this.open() : this.close();
  }

  close() {
    this.classList.remove('is-open');
    this.isOpen = false;
    document.body.classList.remove('ia-overflow-hidden');
    window.iaTheme.showExtraStickyElements();
  }
  
  open() {
    this.classList.add('is-open');
    this.isOpen = true;
    if (document.documentElement.scrollHeight > document.documentElement.clientHeight) {
      !this.classList.contains('ia-modal') && document.body.classList.add('ia-overflow-hidden');
    }
    window.iaTheme.hideExtraStickyElements();
    this.dispatchEvent(new CustomEvent('ia-drawer-opened', {
      detail: {
        drawerId: this.id
      }
    }));
  }
}


// Only define custom element if not already defined
if (!customElements.get('ia-drawer-component')) {
  customElements.define('ia-drawer-component', IaDrawer);
}


class IaDrawerClose extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.close.bind(this));
  }


  close() {
    const drawerId = this.dataset.drawerId;
    document.querySelector(`[data-drawer-id="${drawerId}"]`)?.close();
  }
}

if (!customElements.get('ia-drawer-close')) {
  customElements.define('ia-drawer-close', IaDrawerClose);
}


// Export DrawerMenu class for completeness
export class IaDrawerMenu extends IaDrawer {
  constructor() {
    super();
    this.submenuOpener = this.querySelectorAll('[data-sub-menu-opener]');
    this.parentMenu = this.querySelector('[data-parent-menu]');
    this.isSubmenuOpen = false;
    this.submenuOpener?.forEach(submenuOpener => {
      submenuOpener.addEventListener('click', this.toggleSubmenu.bind(this));
    });
  }

  toggleSubmenu(event) {
    event.preventDefault();
    this.isSubmenuOpen = !this.isSubmenuOpen;
    const submenuId = event.currentTarget.dataset.subMenuOpener;
    const submenu = this.querySelector(`[data-sub-menu="${submenuId}"]`);
    submenu?.classList.toggle('is-open', this.isSubmenuOpen);
    if (submenu && submenu.classList.contains('is-open')) {
      this.parentMenu?.classList.add('ia-hidden');
    } else {
      this.parentMenu?.classList.remove('ia-hidden');
    }
    this.querySelectorAll(`[data-sub-menu]`)?.forEach(anotherSubmenu => {
      if (anotherSubmenu.dataset.subMenu !== submenuId) {
        anotherSubmenu.classList.remove('is-open');
      }
    });
  }

  close() {
    super.close();
    this.isSubmenuOpen = false;
    this.querySelectorAll(`[data-sub-menu]`)?.forEach(anotherSubmenu => {
      anotherSubmenu.classList.remove('is-open');
    });
    this.parentMenu?.classList.remove('ia-hidden');
  }
}

// Only define custom element if not already defined
if (!customElements.get('ia-menu-drawer')) {
  customElements.define('ia-menu-drawer', IaDrawerMenu);
}

class IaDropdown extends IaDrawer {
  constructor() {
    super();
  }
}

if (!customElements.get('ia-dropdown')) {
  customElements.define('ia-dropdown', IaDropdown);
}
